import { createSlice } from "@reduxjs/toolkit";
import { fetchGetProduct } from "../../services/product";

const initialState = {
  products: false,
  notProducts: false,
  isLoading: false,
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchGetProduct.fulfilled, (state, action) => {
      state.products = action.payload?.data?.products;
      state.notProducts = action.payload?.data?.products?.length === 0;
      state.isLoading = false;
    });
    builder.addCase(fetchGetProduct.pending, (state, action) => {
      state.products = false;
      state.isLoading = true;
    });
  },
});

export const {} = productSlice.actions;

export default productSlice.reducer;
